export default "__VITE_ASSET__DrfE4GoG__"